import { Provider } from "react-redux";
import PageRouter from "./PageRouter";
import { store } from "./Redux/sagas";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51LLrycE26qcfcvFI37ItOpxKFpVnXgFWfeeyi2QjjMZEkYUfPrHCTYeL8bNWoaFIVaGqsaGbPOO4156cOWtM024V00LCQK12z3"
);
function App() {
  return (
    <Provider store={store}>
      <Elements stripe={stripePromise}>
        <PageRouter />
      </Elements>
    </Provider>
  );
}

export default App;
